declare const ENV: {
  API_URL?: string;
} | undefined;

// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const envApiUrl = typeof ENV !== 'undefined' ? ENV?.API_URL : undefined;
const API_URL = envApiUrl ?? 'https://api.adalong.com';

export default API_URL;
